import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { CbFormsModule } from '@app/shared/components/forms/forms.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { CbDialogModule } from '@app/shared/components/dialog/dialog.module';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';
import { CbDisplayValueModule } from '@app/shared/components/display-value/display-value.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CbInfiniteScrollModule } from 'projects/cb-hub-lib/src/lib/directives/infinite-scroll/infinite-scroll.module';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { CbInfoMessageModule } from 'projects/cb-hub-lib/src/lib/components/info-message/info-message.module';
import { RouterModule } from '@angular/router';
import { CbDasherModule } from 'projects/cb-hub-lib/src/lib/pipe/dasher/dasher.module';
import { CbButtonModule } from '@app/shared/components/button/button.module';
import { CbTabRouteModule } from '@app/shared/directives/tab-route/tab-route.module';
import { CbSortByModule } from '@app/shared/pipe/sort-by/sort-by.module';
import { CbSortByImpureModule } from '@app/shared/pipe/sort-by-impure/sort-by-impure.module';
import { QsTeamAreaComponent } from './qs-team-area/qs-team-area.component';
import { PricingRevisionsComponent } from './revisions/pricing-revisions.component';
import { CbTableModule, CbSelectListModule } from 'cb-hub-lib';
import { CbHubTableModule } from '@app/shared/components/table/table.module';
import { CbLotCostsModule } from '@app/views/lot/costs/costs.module';
import { TakeoffsComponent } from './takeoffs/takeoffs.component';
import { CbCommonTeamModule } from '../common/common-team.module';

const MATERIAL_MODULES = [
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatCheckboxModule,
    MatCardModule,
    MatDialogModule,
    MatTableModule,
    MatTooltipModule,
    MatMenuModule,
    MatChipsModule,
    MatRadioModule,
    MatTabsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
];

const CB_MODULES = [
    CbInfiniteScrollModule,
    CbDisplayValueModule,
    CbWaitForModule,
    CbDialogModule,
    CbFormsModule,
    CbInfoMessageModule,
    CbDasherModule,
    CbButtonModule,
    CbTabRouteModule,
    CbSortByModule,
    CbSortByImpureModule,
    CbInfiniteScrollModule,
    CbTableModule,
    CbHubTableModule,
    CbLotCostsModule,
    CbCommonTeamModule,
    CbSelectListModule
];

const MISCELLANEOUS_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollDirective,
];

@NgModule({
    declarations: [
        QsTeamAreaComponent,
        PricingRevisionsComponent,
        TakeoffsComponent
    ],
    exports: [
    ],
    imports: [
        RouterModule.forRoot(
            [{
                component: QsTeamAreaComponent,
                path: 'teams/qs',
                data: { breadcrumb: 'Qs Team' },
            },
            {
                component: QsTeamAreaComponent,
                path: 'teams/qs/pricing-revisions',
                data: {
                    breadcrumb: 'Pricing Revisions',
                }
            },
            {
                component: QsTeamAreaComponent,
                path: 'teams/qs/tasks',
                data: {
                    breadcrumb: 'Tasks',
                }
            },
            {
                component: QsTeamAreaComponent,
                path: 'teams/qs/takeoffs',
                data: {
                    breadcrumb: 'Takeoffs',
                }
            },
            {
                component: QsTeamAreaComponent,
                path: 'teams/qs/changes',
                data: {
                    breadcrumb: 'Changes',
                }
            },
            {
                component: QsTeamAreaComponent,
                path: 'teams/qs/questions',
                data: {
                    breadcrumb: 'Questions',
                }
            },],
            {
    onSameUrlNavigation: 'reload'
}
        ),
        ...MATERIAL_MODULES,
        ...MISCELLANEOUS_MODULES,
        ...CB_MODULES
    ]
})
export class CbQsTeamModule { }
